export enum BUSINESS_ENTITY {
    Advertiser = 'ADVERTISER',
    Publisher = 'PUBLISHER',
    Campaign = 'CAMPAIGN',
    Keyword = 'KEYWORD',
    Category = 'CATEGORY',
    Benchmark = 'BENCHMARK',
    Brand = 'BRAND',
}
